module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Bestelling details"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [(_vm.order === null) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner"
  })]) : _c('div', [(_vm.order.customer_note) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', {
    staticClass: "alert-heading font-w400 my-2"
  }, [_vm._v("Notitie van klant:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v(_vm._s(_vm.order.customer_note))])]) : _vm._e(), _vm._v(" "), (_vm.order.gift_wrapping) ? _c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('i', {
    staticClass: "fa fa-info-circle mr-5"
  }), _vm._v(" Deze bestelling moet WEL ingepakt worden.")])]) : _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('i', {
    staticClass: "fa fa-info-circle mr-5"
  }), _vm._v(" Deze bestelling hoeft NIET ingepakt te worden.")])]), _vm._v(" "), _vm._l((_vm.orderNotifications), function(orderNotification) {
    return _c('div', {
      key: orderNotification.id,
      staticClass: "alert alert-info",
      attrs: {
        "role": "alert"
      }
    }, [_c('p', {
      staticClass: "mb-0"
    }, [_c('i', {
      staticClass: "fa fa-info-circle mr-5"
    }), _vm._v(" " + _vm._s(orderNotification.notification_text))])])
  }), _vm._v(" "), (_vm.order.discount_code) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', {
    staticClass: "alert-heading font-w400 my-2"
  }, [_vm._v("Kortingscode:")]), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v(_vm._s(_vm.order.discount_code))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\n          Bestelling #" + _vm._s(_vm.order.number) + "\n          "), _c('order-status-badge', {
    ref: "orderStatus",
    staticClass: "ml-2",
    attrs: {
      "order": _vm.order
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block-options"
  }, [_c('small', {
    staticClass: "mr-1"
  }, [_vm._v("Download:")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "href": _vm.invoicePdfUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o text-danger mr-1"
  }), _vm._v(" Pakbon")]), _vm._v(" "), (_vm.order.shipment) ? _c('a', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "href": _vm.shipmentPdfUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-tag text-warning mr-1"
  }), _vm._v(" Verzendlabel")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block-options"
  }, [_c('small', {
    staticClass: "mr-1"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "href": _vm.invoiceOrderPdfUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o text-danger mr-1"
  }), _vm._v(" Factuur")])])]), _vm._v(" "), _c('order-timeline', {
    attrs: {
      "order": _vm.order
    },
    on: {
      "print:label": _vm.printLabel
    }
  })], 1), _vm._v(" "), (_vm.order.shipping_method === 'pickup') ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-content block-content-full"
  }, [_c('div', {
    staticClass: "py-20 text-center"
  }, [_c('div', {
    staticClass: "font-size-h4 font-w600"
  }, [_vm._v("Wordt opgehaald")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Deze bestelling wordt opgehaald door de klant.")]), _vm._v(" "), (_vm.order.status !== 'completed') ? _c('div', {
    staticClass: "pt-20"
  }, [_c('button', {
    staticClass: "btn btn-rounded btn-alt-success",
    on: {
      "click": _vm.completeOrder
    }
  }, [_c('i', {
    staticClass: "fa fa-check mr-5"
  }), _vm._v(" Bestelling voltooien\n            ")])]) : _vm._e()])])]) : (!_vm.order.shipment) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Verzending aanmaken")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row gutters-tiny"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('package-type', {
    attrs: {
      "icon": "dropbox",
      "selected": _vm.shipment.package_type === 1,
      "provider": _vm.shipmentOptions[1]
    },
    on: {
      "click": function($event) {
        _vm.selectPackageType(1)
      }
    }
  }, [_vm._v("\n              Groot Pakket\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('package-type', {
    attrs: {
      "icon": "folder-open",
      "selected": _vm.shipment.package_type === 2,
      "provider": _vm.shipmentOptions[2]
    },
    on: {
      "click": function($event) {
        _vm.selectPackageType(2)
      }
    }
  }, [_vm._v("\n              Brievenbuspakket\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('package-type', {
    attrs: {
      "icon": "envelope-open",
      "selected": _vm.shipment.package_type === 3,
      "provider": _vm.shipmentOptions[3]
    },
    on: {
      "click": function($event) {
        _vm.selectPackageType(3)
      }
    }
  }, [_vm._v("\n              Envelop\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('package-type', {
    attrs: {
      "icon": "dropbox",
      "selected": _vm.shipment.package_type === 4,
      "provider": _vm.shipmentOptions[4]
    },
    on: {
      "click": function($event) {
        _vm.selectPackageType(4)
      }
    }
  }, [_vm._v("\n              Klein Pakket "), _c('br'), _vm._v(" "), _c('small', [_vm._v("max 3 kg, lengte max 50 cm, omtrek max 111 cm")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center my-20"
  }, [_c('div', {
    attrs: {
      "title": !_vm.showShipmentOptionToggles ? 'Deze opties zijn niet van toepassing op de geselecteerde verzendmethode.' : ''
    }
  }, [_c('label', {
    staticClass: "css-control css-control-primary css-switch",
    class: {
      'disabled': !_vm.showShipmentOptionToggles
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipment.insurance),
      expression: "shipment.insurance"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.showShipmentOptionToggles
    },
    domProps: {
      "checked": Array.isArray(_vm.shipment.insurance) ? _vm._i(_vm.shipment.insurance, null) > -1 : (_vm.shipment.insurance)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.shipment.insurance,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.shipment, "insurance", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.shipment, "insurance", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.shipment, "insurance", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Verzekerd\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-primary css-switch",
    class: {
      'disabled': !_vm.showShipmentOptionToggles
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipment.large_format),
      expression: "shipment.large_format"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.showShipmentOptionToggles
    },
    domProps: {
      "checked": Array.isArray(_vm.shipment.large_format) ? _vm._i(_vm.shipment.large_format, null) > -1 : (_vm.shipment.large_format)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.shipment.large_format,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.shipment, "large_format", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.shipment, "large_format", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.shipment, "large_format", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" XL Pakket\n            ")])]), _vm._v(" "), (_vm.shipment.package_type === 3) ? _c('button', {
    staticClass: "btn btn-hero btn-alt-secondary",
    on: {
      "click": _vm.openPostageStampDetailModal
    }
  }, [_c('i', {
    staticClass: "fa fa-send mr-5 text-primary"
  }), _vm._v("\n            Verzend en print label\n          ")]) : _c('button', {
    staticClass: "btn btn-hero btn-alt-secondary",
    attrs: {
      "disabled": _vm.creatingShipment
    },
    on: {
      "click": _vm.createShipment
    }
  }, [(_vm.creatingShipment) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin mr-5"
  }) : _c('i', {
    staticClass: "fa fa-send mr-5 text-primary"
  }), _vm._v("\n            Verzend en print label\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('order-address', {
    attrs: {
      "order": _vm.order
    }
  }), _vm._v(" "), (_vm.order.contains_sol_product && !_vm.order.shipping_phone) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-danger"
  }, [_c('h3', {
    staticClass: "block-title",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Telefoonnummer")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row justify-content-center py-sm-3 py-md-5"
  }, [_c('div', {
    staticClass: "col-sm-10 col-md-8"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "telephonenumber"
    }
  }, [_vm._v("Telefoonnummer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customerPhonenumber),
      expression: "customerPhonenumber"
    }],
    staticClass: "form-control form-control-alt",
    attrs: {
      "type": "text",
      "id": "telephonenumber",
      "name": "telephonenumber",
      "placeholder": "Vul een telefoon nummer in"
    },
    domProps: {
      "value": (_vm.customerPhonenumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerPhonenumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full block-content-sm bg-body-light"
  }, [_c('button', {
    staticClass: "btn btn-alt-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.setPhonenumber
    }
  }, [_c('i', {
    staticClass: "fa fa-check opacity-50 me-1"
  }), _vm._v(" Vul Villa Madelief nummer in\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-full block-content-sm bg-body-light"
  }, [_c('button', {
    staticClass: "btn btn-alt-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.updatePhonenumber
    }
  }, [_c('i', {
    staticClass: "fa fa-check opacity-50 me-1"
  }), _vm._v(" Submit\n        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Producten")])]), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("EAN")]), _vm._v(" "), _c('th', [_vm._v("Product")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Aantal")]), _vm._v(" "), _c('th', [_vm._v("Locatie")]), _vm._v(" "), _c('th', [_vm._v("Productnummer Leverancier")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.order.lines), function(line) {
    return _c('tr', {
      key: line.id
    }, [_c('td', [_c('a', {
      staticClass: "font-w600",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(line.product.gtin))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.product.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-center font-w600"
    }, [_vm._v(_vm._s(line.quantity))]), _vm._v(" "), _c('td', [(line.product.dropship) ? _c('i', [_vm._v("Wordt nageleverd "), _c('small', [_vm._v(_vm._s(line.product.dropship))]), (line.dropshipment_completed_at) ? _c('small', [_c('i', {
      staticClass: "fa fa-check fa-4x text-success",
      staticStyle: {
        "font-size": "2em"
      }
    })]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(line.product.location))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.product.vendor_product_id || 'N.v.t.'))])])
  }), 0), _vm._v(" "), (_vm.order.contains_sol_product && !_vm.order.weshipp_id) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.orderSolProducts
    }
  }, [_vm._v("Bestel Sol producten")]) : _vm._e()])])])], 2), _vm._v(" "), (_vm.showPostageStampModal) ? _c('postage-stamp-detail-modal', {
    attrs: {
      "order": _vm.order,
      "shipment": _vm.shipment
    },
    on: {
      "close": function($event) {
        _vm.loadOrder(), _vm.showPostageStampModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba4edc04","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/orders/OrderDetailModal.vue
// module id = 752
// module chunks = 1